import { mutationTypes } from '@/core/constants'
import { FiltroUtils } from '@/core/utils'

export default {
	[mutationTypes.PEDIDO.SET_INFORMACOES](state, informacoes) {
		state.informacoesPedido = informacoes
	},
	[mutationTypes.PEDIDO.RESET_INFORMACOES](state) {
		state.informacoesPedido = {}
	},
	[mutationTypes.PEDIDO.SET_NUMERO](state, numero) {
		state.informacoesPedido.numeroPedido = numero
	},
	[mutationTypes.PEDIDO.SET_HAS_AUTORITY](state, hasAuthority) {
		state.bpm.hasAutority = hasAuthority
	},
	[mutationTypes.PEDIDO.SET_ETAPA_FLUXO](state, instanciaFluxo) {
		state.bpm.etapaAtual = {
			atividadeSituacao: (((instanciaFluxo || {}).currentTask || {}).assignee || {}).fullname || '---',
			atividadeNome: ((instanciaFluxo || {}).currentTask || {}).name,
		}
	},
	[mutationTypes.PEDIDO.LIMPAR_FILTRO_LISTAGEM](state) {
		FiltroUtils.limparFiltroAvancado(state.filtro)
	},

	[mutationTypes.PEDIDO.RESETAR_PAGINA_LISTAGEM](state) {
		state.paginacao.page = 1
	},

	[mutationTypes.PEDIDO.SET_PAGINACAO_LISTAGEM](state, paginacao) {
		state.paginacao = paginacao
	},
	[mutationTypes.PEDIDO.SET_ID_ORGAO_ABA](state, idOrgao) {
		state.idOrgao.value = idOrgao
	},
	[mutationTypes.PEDIDO.RESET_ID_ORGAO_ABA](state) {
		state.idOrgao.value = null
	},
	[mutationTypes.PEDIDO.SET_REVISAO](state, revisao) {
		state.revisao = revisao
	},
}
